import React from 'react';

import { ClickableIcon } from '~components';
import { faArrowUpRightFromSquare } from '~components/icon';
import { Row } from '~components/table-view';

interface ComponentProps {
  row?: Row;
}

const DexReadinessActionCell: React.FC<ComponentProps> = ({ row }) => {
  // TAV-2962: a mac_id-only row flags a client-level gap (My Aged Care number), which is
  // editable only on the client's DEX/HACC Settings screen in TP1 - not on this appointment.
  // Sending staff to the appointment's DEX tab for this row would be a dead end.
  const missingFields: string[] = row?.missing_fields ?? [];
  const isMacIdOnly = missingFields.length === 1 && missingFields[0] === 'mac_id';

  const handleClick = () => {
    if (row?.appointment_id) {
      window.open(`/appointments/${row.appointment_id}?tab=dex`, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <ClickableIcon
      id={`dex-readiness-action-${row?.appointment_id ?? 'unknown'}`}
      icon={faArrowUpRightFromSquare}
      onClick={handleClick}
      disabled={isMacIdOnly}
      showTooltipWhenDisabled={isMacIdOnly}
      toolTip={
        isMacIdOnly
          ? "My Aged Care ID is maintained on the client's DEX/HACC Settings screen in TP1, not on this appointment"
          : 'Open appointment'
      }
      ariaLabel={isMacIdOnly ? 'My Aged Care ID editable in TP1 DEX/HACC Settings' : 'Open appointment'}
      dataCy={`dex-readiness-action-${row?.appointment_id ?? 'unknown'}`}
    />
  );
};

export default DexReadinessActionCell;
